import { render, staticRenderFns } from "./NotasMovidasAnteriores.vue?vue&type=template&id=5fb168d3"
import script from "./NotasMovidasAnteriores.vue?vue&type=script&lang=js"
export * from "./NotasMovidasAnteriores.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports